/******************* 
@Purpose : Used for environment configuration
@Parameter : {API_URL, PORT}
@Author : INIC
******************/
module.exports = {
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  API_URL_SSR: process.env.NEXT_PUBLIC_API_URL_SSR,
  PORT: process.env.PORT,
  GOOGLE_ID: process.env.NEXT_PUBLIC_GOOGLE_APP_ID,
  FB_ID: process.env.NEXT_PUBLIC_FB_APP_ID,
  GOOGLE_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
  RECAPTCHA_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
  STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY,
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
  APP_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  CHATBOT_URL: process.env.NEXT_PUBLIC_CHATBOT_URL,
  CHATBOT_WIDGET_ENABLED: process.env.NEXT_PUBLIC_CHATBOT_WIDGET_ENABLED !== "false",
  CHATBOT_ORGANIZATION_ID: (process.env.NEXT_PUBLIC_CHATBOT_ORGANIZATION_ID || "646b7e24-3a27-415e-8dea-13cf3a3208cc").trim(),
  CHATBOT_WIDGET_ID: (process.env.NEXT_PUBLIC_CHATBOT_WIDGET_ID || "225b7424-30a4-4723-af1e-5c299253516b").trim(),
  // CDN_PATH: process.env.NEXT_PUBLIC_LOGO_CDN_PATH,
};
